export class GerarDacteRequest {
  nomeXml: string = '';
  caminhoGcs?: string;
  isDocumentoRecebido: boolean = false;
}
